module.exports = __webpack_public_path__ + "static/redbrick-logo-d4ca4449b5bdc6c453a5ce4faa74e6db.png";